import React, { useState, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import "../styles/Sidebar.css";
import Loading from "../components/Loader";
import { matchPath } from "react-router-dom";
import MiniDash from "./MiniDash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLandmark, faUserSecret, faUserCog, faCircleDollarToSlot, faReceipt } from "@fortawesome/free-solid-svg-icons";


function Sidebar() {
    const auth = getAuth();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [isAdminOpen, setIsAdminOpen] = useState(false);

    const toggleAdminDropdown = () => {
        setIsAdminOpen(!isAdminOpen);
    };


    
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
            if (authUser) {
                setUser(authUser);
                const userDocRef = doc(db, "stock", authUser.uid);
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setUserRole(userData.role || null);
                } else {
                    console.log("No user document found");
                }
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [auth]);

    if (loading) {
        return <Loading />;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    // Function to check if the current route matches the given path or pattern
    const isActive = (path) => {
        const match = matchPath(path, location.pathname);
        return match !== null;
    };

    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                console.log("User signed out");
                navigate("/");
            })
            .catch((error) => console.error("Error signing out: ", error));
    };

    return (
        <div className="sidebar">
            <MiniDash />
            <Link to="/" className={`routeLinks ${isActive("/") ? "active" : ""}`}>
                <FontAwesomeIcon icon={faLandmark} className="icon" />  Dashboard
            </Link>

            {userRole === "admin" && (
                <div className="admin-dropdown-container">
                    <div
                        className="admin-dropdown-header"
                        onClick={toggleAdminDropdown}
                    >
                        <FontAwesomeIcon icon={faUserSecret} className="icon" />  For Admin Only
                    </div>

                    {isAdminOpen && (
                        <ul className="admin-dropdown-list">
                            <li className="admin-dropdown-item">
                                <Link
                                    to="/get-admin"
                                    className={`admin-link ${isActive("/get-admin") ? "active" : ""}`}>
                                    -  All Users
                                </Link>
                            </li>
                            <li className="admin-dropdown-item">
                                <Link
                                    to="/userdetail/add-transaction"
                                    className={`admin-link ${isActive("/userdetail/add-transaction") ? "active" : ""}`}>
                                    -  Add Transaction
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>
            )}

  <Link to="/transactions" className={`routeLinks ${isActive("/transactions") ? "active" : ""}`}>
                <FontAwesomeIcon icon={faReceipt} className="icon" /> All Transactions
            </Link>

            <Link to="/investments" className={`routeLinks ${isActive("/investments") ? "active" : ""}`}>
                <FontAwesomeIcon icon={faCircleDollarToSlot} className="icon" /> About Us
            </Link>

            <Link to={`/user/${user.uid}`} className={`routeLinks ${isActive(`/user/${user.uid}`) ? "active" : ""}`}>
                <FontAwesomeIcon icon={faUserCog} className="icon" /> Profile
            </Link>

            <div onClick={handleLogout} className="log-out">
                Logout
            </div>
        </div>
    );
}

export default Sidebar;
